import React, { useEffect, useState } from "react";
import avatarPlaceholder from "../../assets/img/userPlaceholderAvatar.png";

interface TypeImage extends React.ImgHTMLAttributes<HTMLImageElement> {
    source: string;
    size?: number;
    classes?: string;
};

export default function Image({ source, size, classes }: TypeImage) {

    const [localSource, setLocalSource] = useState<string>(source);

    useEffect(() => {
        setLocalSource(source || avatarPlaceholder);
    }, [source]);

    return (
        <img
            // crossOrigin={"anonymous"}
            className={classes || ''}
            src={localSource}
            onError={() => {
                setLocalSource(avatarPlaceholder);
            }}
            alt="No Image"
            width={size}
            height={size}
            style={{ objectFit: 'cover' }}
        />
    );
}